import React, { useRef, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import LetterFormatB from "./letter-format-b";
import { useReactToPrint } from "react-to-print";
import { LeaveRequest } from "../../interfaces/letters";

interface Props {
  item: LeaveRequest;
}

const EmployeeLeaveRequest = ({ item }: Props) => {
  const probationRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => probationRef.current,
  });

  useEffect(() => {
    handlePrint();
  }, []);

  return (
    <div className="letter-container position-relative" ref={probationRef}>
      <LetterFormatB heading="Employee Leave Request" data="hello">
        <h4 className="sub-heading mt-5">Employee Detail</h4>
        <Row>
          <Col sm="4">
            <div className="emp-detail-item">
              <h4
                className="sub-heading normal-font-weight textBlack mb-2"
                style={{ fontSize: "18px" }}
              >
                Emp ID:
              </h4>
              <p
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.empId}
              </p>
            </div>
          </Col>
          <Col sm="4">
            <div className="emp-detail-item">
              <h4
                className="sub-heading normal-font-weight textBlack mb-2"
                style={{ fontSize: "18px" }}
              >
                Emp Name:
              </h4>
              <p
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.empName}
              </p>
            </div>
          </Col>
          <Col sm="4">
            <Form.Group className="mb-5">
              <h4
                className="sub-heading normal-font-weight textBlack"
                style={{ fontSize: "18px" }}
              >
                Project Id
              </h4>
              <h5
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.projectId}
              </h5>
            </Form.Group>
          </Col>
          <Col sm="4">
            <Form.Group className="mb-5">
              <h4
                className="sub-heading normal-font-weight textBlack"
                style={{ fontSize: "18px" }}
              >
                Project Name
              </h4>
              <h5
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.projectName}
              </h5>
            </Form.Group>
          </Col>
          <Col sm="4">
            <Form.Group className="mb-5">
              <h4
                className="sub-heading normal-font-weight textBlack"
                style={{ fontSize: "18px" }}
              >
                Project Supervisor
              </h4>
              <h5
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.projectSupervisor}
              </h5>
            </Form.Group>
          </Col>
          <Col sm="4">
            <Form.Group className="mb-5">
              <h4
                className="sub-heading normal-font-weight textBlack"
                style={{ fontSize: "18px" }}
              >
                Last Salary Status
              </h4>
              <h5
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.lastSalaryStatus}
              </h5>
            </Form.Group>
          </Col>
          <Col sm="4">
            <Form.Group className="mb-5">
              <h4
                className="sub-heading normal-font-weight textBlack"
                style={{ fontSize: "18px" }}
              >
                Leave Category
              </h4>
              <h5
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.leaveCategory}
              </h5>
            </Form.Group>
          </Col>
          <Col sm="4">
            <Form.Group className="mb-5">
              <h4
                className="sub-heading normal-font-weight textBlack"
                style={{ fontSize: "18px" }}
              >
                Leave From
              </h4>
              <h5
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.leaveFrom
                  ? new Date(item.leaveFrom).toLocaleDateString()
                  : ""}
              </h5>
            </Form.Group>
          </Col>
          <Col sm="4">
            <Form.Group className="mb-5" controlId="formBasicEmail">
              <h4
                className="sub-heading normal-font-weight textBlack"
                style={{ fontSize: "18px" }}
              >
                Leave To
              </h4>
              <h5
                className="sub-heading normal-font-weight"
                style={{ fontSize: "16px" }}
              >
                {item.leaveTo
                  ? new Date(item.leaveTo).toLocaleDateString()
                  : ""}
              </h5>
            </Form.Group>
          </Col>
        </Row>
        <div style={{ position: "absolute", bottom: "80px" }}>
          <h4 className="sub-heading normal-font-weight text-black mt-6 mb-1">
            Approved By:
          </h4>
          <div className="signature-authority d-flex gap-5">
            <div className="authority">
              <h4 className="sub-heading text-black">Supervisor</h4>
              <p
                className="para-medium text-black mb-0"
                style={{ fontSize: "20px", fontWeight: "600" }}
              >
                23, May 2022
              </p>
            </div>
            <div className="authority">
              <h4 className="sub-heading text-black">Supervisor Coordinator</h4>
              <p
                className="para-medium text-black mb-0"
                style={{ fontSize: "20px", fontWeight: "600" }}
              >
                23, May 2022
              </p>
            </div>
            <div className="authority">
              <h4 className="sub-heading text-black">HR Manager</h4>
              <p
                className="para-medium text-black mb-0"
                style={{ fontSize: "20px", fontWeight: "600" }}
              >
                23, May 2022
              </p>
            </div>
          </div>
        </div>
      </LetterFormatB>
    </div>
  );
};

export default EmployeeLeaveRequest;
